import clsx from "clsx";
import { QQSection, RadioButton, Button, Label, ToolTip } from "common/components";
import { FileType } from "./types";
import React, { useState } from "react";
import styles from "./FileTypeForm.module.scss";

interface FileTypeFormProps {
  type: FileType | null;
  onSubmit: (fileType: FileType) => void;
}

const toolTipContinue = "Continue to Upload your File";
const toolTipDisabled = "Choose Material Buy list or Nested file";

export const FileTypeForm: React.FC<FileTypeFormProps> = ({ type, onSubmit }) => {
  const [canContinue, setCanContinue] = useState<boolean>(() => (type !== null ? true : false));
  const [fileType, setFileType] = useState<FileType | null>(type);
  const [toolTipText, setToolTipText] = useState<string>(toolTipDisabled);
  const [expandedOptions, setExpandedOptions] = useState<Set<FileType>>(new Set());

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFileType(parseInt(event.target.value));
    setToolTipText(toolTipContinue);
    setCanContinue(true);
  };

  const onClick = () => {
    if (fileType !== null) onSubmit(fileType);
  };

  const toggleExpanded = (option: FileType) => {
    const newExpanded = new Set(expandedOptions);
    if (newExpanded.has(option)) {
      newExpanded.delete(option);
    } else {
      newExpanded.add(option);
    }
    setExpandedOptions(newExpanded);
  };

  return (
    <QQSection className="pt-24 pb-16" separator={false} blue bottomSection>
      <form>
        <div className={clsx(styles.formContainer, "mx-auto")}>
          <div className="d-flex justify-content-center">
            <div className={clsx(styles.fileOption, styles.fileOption1, "mr-44")}>
              <div className={styles.optionHeader}>
                <div className="form-check form-check-inline">
                  <RadioButton
                    id="nested"
                    name="type"
                    value={FileType.Nested}
                    checked={fileType === FileType.Nested}
                    onChange={onChange}
                    tabIndex={0}
                    large
                    className="mr-10"
                  />
                  <Label htmlFor="nested" className="font-size-16 text-nowrap">
                    Material Buy List
                  </Label>
                </div>
                <button
                  type="button"
                  className={styles.expandButton}
                  onClick={() => toggleExpanded(FileType.Nested)}
                  aria-expanded={expandedOptions.has(FileType.Nested)}
                >
                  <span className={styles.briefText}>Use lengths as specified in file.</span>
                  <i
                    className={clsx(styles.arrow, {
                      [styles.expanded]: expandedOptions.has(FileType.Nested),
                    })}
                  ></i>
                </button>
              </div>
              {expandedOptions.has(FileType.Nested) && (
                <div className={styles.expandedContent}>
                  <div className="font-size-14 m-0 mt-12 text-light">
                    <p className="m-0">
                      The tool will check availability from rollings and multiple stock options and
                      generate a quote that best meets your needs.
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className={clsx(styles.fileOption, styles.fileOption2, "mr-40")}>
              <div className={styles.optionHeader}>
                <div className="form-check form-check-inline">
                  <RadioButton
                    id="unnested"
                    name="type"
                    value={FileType.Unnested}
                    checked={fileType === FileType.Unnested}
                    onChange={onChange}
                    tabIndex={0}
                    large
                    className="mr-10"
                  />
                  <Label htmlFor="unnested" className="font-size-16 text-nowrap">
                    Uncombined Material List
                  </Label>
                </div>
                <button
                  type="button"
                  className={styles.expandButton}
                  onClick={() => toggleExpanded(FileType.Unnested)}
                  aria-expanded={expandedOptions.has(FileType.Unnested)}
                >
                  <span className={styles.briefText}>Combine lengths to mill capable lengths.</span>
                  <i
                    className={clsx(styles.arrow, {
                      [styles.expanded]: expandedOptions.has(FileType.Unnested),
                    })}
                  ></i>
                </button>
              </div>
              {expandedOptions.has(FileType.Unnested) && (
                <div className={styles.expandedContent}>
                  <div className="font-size-14 m-0 mt-12 text-light">
                    <p className="m-0">
                      The tool will combine similar material components and convert to mill capable
                      lengths, check availability from rollings and multiple stock options and
                      generate a quote that best meets your needs.
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="align-center text-center">
              <ToolTip placement="top" popOverText={toolTipText} enableTip={!canContinue}>
                <span className="d-inline-block">
                  <Button
                    disabled={!canContinue}
                    className={clsx({ [styles.pointerEvents]: !canContinue })}
                    onClick={onClick}
                    type="button"
                  >
                    Continue
                  </Button>
                </span>
              </ToolTip>
            </div>
          </div>
        </div>
      </form>
    </QQSection>
  );
};
